/* eslint-disable no-console -- the logger is the single place allowed to write to the console */
const LOG_COLOR = '#1e88e5';

export const logger = {
  log: (message: string, ...args: unknown[]) => {
    console.info('%c%s', `color: ${LOG_COLOR}`, message, ...args);
  },
  error: (message: string, ...args: unknown[]) => {
    console.error(message, ...args);
  },
};
